import React, { useState, useEffect, useRef } from 'react';
import style from '../../css/Navlinkpage/Storysuccess.module.css';
import gsap from 'gsap';

const Storysuccess = () => {
    const [activeIndex, setActiveIndex] = useState(0); // Default active index
    const contentRef = useRef(null);
    const imageRef = useRef(null);

    const years = [
        { year: 2021, image: 'https://i.ibb.co/CKNmhMX/blog1.jpg', content: 'Content for 2021' },
        { year: 2022, image: 'https://i.ibb.co/m5yGbdR/blog2.jpg', content: 'Content for 2022' },
        { year: 2023, image: 'https://i.ibb.co/YXV3zmh/blog3.jpg', content: 'Content for 2023' },
        { year: 2024, image: 'https://i.ibb.co/CKNmhMX/blog1.jpg', content: 'Content for 2024' },
        { year: 2025, image: 'https://i.ibb.co/m5yGbdR/blog2.jpg', content: 'Content for 2025' },
    ];

    useEffect(() => {
        if (contentRef.current && imageRef.current) {
            gsap.fromTo(
                contentRef.current,
                { opacity: 0, x: -50 },
                { opacity: 1, x: 0, duration: 0.5, ease: 'power3.out' }
            );
            gsap.fromTo(
                imageRef.current,
                { opacity: 0, x: 50 },
                { opacity: 1, x: 0, duration: 0.5, ease: 'power3.out' }
            );
        }
    }, [activeIndex]);

    return (
        <section className={style.historyArea}>
            <div className={style.container}>
                {/* Year Navigation at the Top */}
                <div className={`text-center ${style.yearNavigation}`}>
                    {years.map((item, index) => (
                        <span 
                            key={index} 
                            className={`${style.yearButton} ${index === activeIndex ? style.activeYear : ''}`} 
                            onClick={() => setActiveIndex(index)}
                            style={{ cursor: 'pointer', margin: '0 10px', fontSize: '18px', fontWeight: 'bold' }}
                        >
                            {item.year}
                        </span>
                    ))}
                </div>

                {/* Content Section */}
                <div className={`${style.row} ${style.contentWrapper}`}>
                    <div className={`${style.col6} ${style.imageContainer}`} ref={imageRef}>
                        <div className={style.historyImg}>
                            <img className="img-fluid" src={years[activeIndex].image} alt={`Year ${years[activeIndex].year}`} />
                        </div>
                    </div>
                    <div className={`${style.col6} ${style.textContainer}`} ref={contentRef}>
                        <div className={style.historyContent}>
                            <h2 className={style.columnTitle}>{years[activeIndex].year}</h2>
                            <p>{years[activeIndex].content}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Storysuccess;
